import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';

const Ticker = props => {
    
    const news = props.news && [...props.news.slice(0, 3)];
    
    const [currentActive, setActive] = useState(0);

    return (
        <div className={classNames({
            'ticker': true,
            ...props.modifiers
        })}>
            <span className="ticker__byline">Aktuellt</span>
            <div className={classNames({
                'ticker__news': true,
                'ticker__news--is-loading': props.isLoading
            })}>
                {news && news.map((n, i) => {
                    return (
                        <Link key={`tick${n.slug}`} to={`/news/${n.slug}`} className={classNames({
                            'ticker__item': true,
                            'ticker__item--is-active': currentActive === i,
                        })}>{n.header}</Link>
                    );
                })}
            </div>
            <div className={classNames({
                'ticker__controls': true,
                'ticker__controls--is-loading': props.isLoading
            })}>
                <button className="ticker__btn ticker__btn--prev" type="button" onClick={() => {
                    setActive(currentActive === 0 ? news.length-1 : currentActive-1);
                }}><span>Föregånde nyhet</span></button>
                <button className="ticker__btn ticker__btn--next" type="button" onClick={() => {
                    setActive(currentActive === news.length-1 ? 0 : currentActive+1);
                }}><span>Nästa nyhet</span></button>
                <Link className="ticker__allnews" to="/news">Alla nyheter</Link>
            </div>
        </div>
    );
};

export default Ticker;